import { BACKEND_URL } from "../../config";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const trainingApi = createApi({
  reducerPath: "trainingApi",
  keepUnusedDataFor: 45 * 60,
  refetchOnMountOrArgChange: true,
  tagTypes: ["TrainingApi"],
  refetchOnReconnect: true,
  baseQuery: fetchBaseQuery({
    baseUrl: `${BACKEND_URL}/training/portal/`,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.token;
      if (token) {
        // include token in req header
        headers.set("authorization", `Bearer ${token}`);
      }
      return headers;
    },
    fetchFn: async (input, init) => {
      const response = await fetch(input, init);
      if (response.status === 204) {
        return new Response(JSON.stringify([]), { status: 200 });
      }
      return response;
    },
  }),
  endpoints: (builder) => ({
    getTrainingTaskPageDetails: builder.query({
      query: () => `get-training-task-page`,
    }),
    getRepCardMiniButtons: builder.query({
      query: () => `get-rep-card-mini-buttons`,
    }),
    providesTags: ["TrainingApi"],
  }),
});

export const { useGetTrainingTaskPageDetailsQuery, useGetRepCardMiniButtonsQuery } = trainingApi;
